<template>
    <div>
        <v-dialog v-model="attendAppointmentModal" max-width="560px" content-class="add-appointment view-edit">
            <v-card class="event-panel">
                <div class="modal-header">
                    <h4 class="modal-headline">
                        {{ appointment.name }}
                    </h4>
                    <div class="tools">
                        <v-btn icon @click="attendAppointmentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <div class="clients-list1">
                            <v-progress-circular 
                            v-show="clientsLoading" 
                            class="clients-loader" indeterminate color="primary"></v-progress-circular>
                            <v-autocomplete
                                :search-input.sync="editSearchMembers"
                                :items="editResultMembers" 
                                :placeholder="$page.props.lang.searchMembers || 'Search members'"
                                @change="addMemberCheck"
                                item-text="full_name" 
                                return-object
                                :loading="isLoading" append-icon=""
                                hide-no-data  
                                outlined 
                                dense
                                class="search-members">
                                <template v-slot:selection=""></template>
                            </v-autocomplete>

                            <v-card-text 
                                v-if="!appointment.members.length" 
                                v-html="$page.props.lang.no_members_added || 'No members added in this appointment.<br> Search for members that You want to add in appointment.'" 
                                class="text-center ">
                            </v-card-text>
                        
                            <v-expansion-panels v-show="!clientsLoading" v-else>
                                <member-attended v-for="member in appointment.members" :key="member.id" :member="member" :appointment="appointment"></member-attended>
                            </v-expansion-panels>

                        </div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                            @click="attendAppointmentModal = false"
                            color="primary" absolute right bottom>OK</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmCompleteModal" max-width="560px" content-class="add-appointment view-edit">
            <v-card class="event-panel">
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.confirmComplete || "Confirm complete" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="confirmCompleteModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <div class="clients-list">
                            <v-progress-circular 
                            v-show="false" 
                            class="clients-loader" indeterminate color="primary"></v-progress-circular>
                            <p class="text">{{ $page.props.lang.attendanceNotCheckedInfo || "Fot these clients attendance is not checked." }}:</p>
                            <ul class="list">
                                <li class="client" v-for="client in confirmCompleteClients" :key="client.id">
                                    <p class="name">
                                        <v-avatar size="30">
                                            <img :src="client.member_photo_path" alt="">
                                        </v-avatar>
                                        {{client.full_name}}
                                    </p>
                                </li>
                            </ul>
                            <p class="text">{{ $page.props.lang.attendanceNotCheckedWarning || "Click on confirm will mark all clients as checked." }}</p>
                        </div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                            @click="completeAppointment(true)"
                            color="primary">{{ $page.props.lang.confirm || "Confirm" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <ReccuringModal :open="showAddAllModal"
        @no="addMember(false)" 
        @yes="addMember(true)"
        @close="showAddAllModal = false"
        :description="$page.props.lang.addToAllConfirmDescription || 'Do You want to add member only to this or this and all future events?'"
        :noText="$page.props.lang.addToAllConfirmNoText || 'Only to this'" 
        :yesText="$page.props.lang.addToAllConfirmYesText || 'To this and all future'">
        </ReccuringModal>
        
        <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>
    </div>
</template>

<script>

import MemberAttended from './MemberAttended'
import EventBus from '@/js/eventbus'
import ReccuringModal from '@/js/Pages/Backoffice/Calendar/Components/ReccuringModal'

export default {
    components:{
        MemberAttended,
        ReccuringModal
    },
    props: {
        open: Boolean,
        trainers: Array,
        appointment: Object,
        clientsLoading: Boolean,
    },
    data(){
        return {
            statusItems: [
                { title: this.$page.props.lang.canceled || 'Canceled', value: -1},
                { title: this.$page.props.lang.missing || 'Missing', value: 0},
                { title: this.$page.props.lang.attended || 'Attended', value: 1}
            ],
           // selectedMembers: [],
            checkedBoxes: [],
            confirmCompleteModal: false,
            confirmCompleteClients: [],
            messageObjects: [],
            currentSubscription: null,
            errors: {}, 
            editSearchMembers: null,
            isLoading: false,
            editResultMembers: [],
            showAddAllModal: false,
            add_all: false,
            add_one: false,
            currentMember: null,
            model: {
                subscription_id: null,
                period_id: null,
                status: null,
                charge: false,
                appointment_id: null,
                member_id: null
            } 
        }
    },
    created(){

        EventBus.$on('REMOVE_MEMBER_FROM_APPOINTMENT', (p) => {
            let member = this.appointment.members.find(i => i.id == p.id);

            if(member != null){
                this.appointment.members.splice(this.appointment.members.indexOf(member), 1);
            }
        });
        
    },
    computed: {
        attendAppointmentModal: {
            get: function() {
                return this.open
            },
            set: function() {
               this.$emit('close')
                return false
            }
        }
    },
    watch: {
        editSearchMembers(val) {
            if (val === null) {
                this.editResultMembers = []
                return
            } 
            if(this.editResultMembers.length > 0) return
            if (this.isLoading) return

            this.isLoading = true

            axios.get('/backoffice/lookup/members', { params: { search: val }})
                .then(response => {
                    this.editResultMembers = response.data.results
                    this.isLoading = false
                })
        },

        attendAppointmentModal(val) {
            if (val===false) {
                this.checkedBoxes = []
            }
        },
        model: {
            deep: true,
            handler: function(val, oldVal){
                this.currentSubscription = this.appointment.members.subscriptions.find(i => i.id == val.subscription_id);
                this.model.period_id = this.currentSubscription.period_id;
            }
        },
    },
    methods: {
        showCheck(index) {
            if (this.appointment.clients[index].status===1) {
                this.appointment.clients[index].apply_charge = true
            }
            this.checkedBoxes[index] = true
        },
        saveMemberStatus(clientId, index) {
    
            let statusPack = {}
            statusPack = {
                id: this.appointment.id, 
                member_id: clientId, 
                status: this.appointment.members[index].status,
                apply_charge: this.appointment.members[index].apply_charge,
            }
            
            axios.post('/backoffice/calendar/appointment/memberStatus', statusPack)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.messageObjects.push({ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
        },
        completeAppointment(value) {
            let completePack = {
                id: this.appointment.id,
                force_complete: value
            }
            axios.post('/backoffice/calendar/appointment/completed', completePack)
                .then(response => {
                    
                    if (response.data.status==="OK") {
                        this.attendAppointmentModal = false;
                        this.confirmCompleteModal = false;
                        this.$emit('fetchCurrent')
                        this.messageObjects.push({ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    } else if (response.data.status==="CONFIRMATION") {
                        this.confirmCompleteModal = true;
                        
                        this.confirmCompleteClients = response.data.members;
                        this.confirmCompleteClients.map(item => {
                            item.member_photo_path = item.member_photo_path + '?w=60'
                            return item
                        })
                    }
                })
        },

        addMemberCheck(member){
            this.currentMember = member;

            if(this.appointment.parent_id != null || this.appointment.recurring == 1){
                this.showAddAllModal = true;
            }else{
                this.addMember(false);
            }
        },

        addMember(recurring){
           
           this.editSearchMembers = "";

           axios.post('/backoffice/calendar/appointment/addmember', {
               id: this.appointment.id,
               member_id: this.currentMember.id,
               add_to_all: recurring

           }).then((r) => {

               if(r.data.status === "OK"){
                   this.showAddAllModal = false;
                   this.appointment.members.push(r.data.member);
                   this.$inertia.reload();
               }
                else {
                   this.messageObjects.push({ 
                        message: r.data.message,
                        color: 'error',
                        timeout: 5000
                    });
               }

           });
        }
    }
}
</script>